import { useSession } from 'src/contexts/SessionContext';
import {
  ClientListFilters,
  formatClientListFilters,
} from 'src/models/client/client';
import { useListSearchParams } from 'src/utils/useListSearchParams';

export const CLIENT_LIST_PARAM_PREFIX = 'client_';

export const useClientBulkFilters = (selectAll: boolean) => {
  const { session } = useSession();
  const { params, filterParams } = useListSearchParams({
    paramPrefix: CLIENT_LIST_PARAM_PREFIX,
  });

  const filters: ClientListFilters | undefined = selectAll
    ? formatClientListFilters(filterParams, session.trainerId)
    : undefined;

  return { params, filters };
};
